import { NgModule } from '@angular/core';

import { AddCustomerFromBranchComponent }            from './customer.add-from-branch.component';
import { CustomerBranchHistoryComponent }            from './customer.branch-history.component';
import { CustomerActivityLogsComponent }             from './customer.activity-logs.component';
import { CustomerChangeComponent }                   from './customer-change.component';
import { CustomerEmailStatementComponent }           from './customer-email-statement.component';
import { CustomerComponent }                         from './customer.component';
import { CustomerIntegrationsService }               from './customer-integrations.service';
import { CustomerResolveMatchesComponent }           from './customer-resolve-matches.component';
import { CustomerSendPortalInvitationComponent }     from './customer-send-portal-invitation.component';
import { CustomerStatementSettingsComponent }        from './customer-statement-settings.component';
import { CustomersListComponent }                    from './customers.list.component';
import { CustomerTypePipe }                          from './customer.type.pipe';
import {
  BranchInvoicesPlaceholderComponent,
  CustomerBranchPaymentsPlaceholderComponent,
  CustomerBranchStorePaymentsPlaceholderComponent
} from './customer.placeholder-components';
import { CustomersModule as AppCustomersModule } from '../../app/customers/customers.module';
import { SharedModule }                   from '../shared/shared.module';
import { TableModule }                    from '../table/table.module';

@NgModule({
  declarations: [
    AddCustomerFromBranchComponent,
    BranchInvoicesPlaceholderComponent,
    CustomerBranchHistoryComponent,
    CustomerActivityLogsComponent,
    CustomerBranchPaymentsPlaceholderComponent,
    CustomerBranchStorePaymentsPlaceholderComponent,
    CustomerChangeComponent,
    CustomerComponent,
    CustomerEmailStatementComponent,
    CustomerResolveMatchesComponent,
    CustomerSendPortalInvitationComponent,
    CustomerStatementSettingsComponent,
    CustomersListComponent,
    CustomerTypePipe
  ],
  entryComponents: [
    AddCustomerFromBranchComponent,
    BranchInvoicesPlaceholderComponent,
    CustomerBranchHistoryComponent,
    CustomerActivityLogsComponent,
    CustomerBranchPaymentsPlaceholderComponent,
    CustomerBranchStorePaymentsPlaceholderComponent,
    CustomerChangeComponent,
    CustomerComponent,
    CustomerEmailStatementComponent,
    CustomerResolveMatchesComponent,
    CustomerSendPortalInvitationComponent,
    CustomerStatementSettingsComponent,
    CustomersListComponent
  ],
  exports: [
    BranchInvoicesPlaceholderComponent,
    CustomerBranchPaymentsPlaceholderComponent,
    CustomerBranchStorePaymentsPlaceholderComponent,
    CustomerTypePipe,
    CustomersListComponent,
  ],
  imports: [
    AppCustomersModule,
    SharedModule,
    TableModule
  ],
  providers: [
    CustomerIntegrationsService,
    CustomerTypePipe,
    {
      provide : 'customerType',
      useClass: CustomerTypePipe
    }
  ]
})
export class CustomersModule {}
